<script>
export default {
  name: 'CardsCount',
  props: {
    cards: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<template>
  <div class="upcoming-card main-block my-9 text-center">
    <div class="cards__number">{{ $BN(cards) | amount(0) }}</div>
    <div class="cards__text">Common Cards Left</div>
  </div>
</template>

<style lang="scss">
.cards {
  &__number {
    font-weight: 600;
    font-size: 4.4rem;
  }

  &__text {
    font-weight: 500;
    font-size: 2rem;
  }
}
</style>
